export default "__VITE_ASSET__DRqLhc5V__"